<template>
  <div class="loading">
    <Spinner />
  </div>
</template>

<script>
import Spinner from './Spinner';
export default {
  name: 'FullScreenSpinner',
  components: { Spinner },
};
</script>
<style lang="scss" scoped>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999999;
  overflow: auto;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
